export const AI_NAME_MAX_LENGTH = 24
export const EMAIL_MAX_LENGTH = 74
export const LABEL_MAX_LENGTH = 32
export const PROJECT_NAME_MAX_LENGTH = 40
export const PROJECT_PREFIX_MAX_LENGTH = 2
export const TEAM_TITLE_MAX_LENGTH = 32
export const TEXT_FIELD_MAX_LENGTH = 255
export const TITLE_MAX_LENGTH = 130
export const TITLE_SMART_TRUNCATE_START = 115
